export default __webpack_public_path__ + "static/media/logo.a1df853b.webp";